import { AfterContentInit, AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../../../globals';
import { OfficeLocationsService } from './office-locations.service';
import { ClientLocationDataModel } from '../../../models/clients/client-location-data.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '../../../services/dialog.service';
import { AddressDataModel } from '../../../models/person/address-data.model';
import { OrganizationDataModel } from '../../../models/organization/organization-data.model';
import { ProceduresService } from '../procedures/procedures.service';
import { ProcedureSelectionDialogModel } from '../../../dialog/procedure-selection-dialog/models/procedure-selection-dialog.model';
import { TdoTableSelectionEvent } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { TdoTableV2Component } from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { OrganizationConfigurationDialogComponent } from '../organization-configuration/dialogs/organization-configuration-dialog/organization-configuration-dialog.component';
import { Constants } from '../../../constants';
import { NonWorkingDaysService } from '../../../services/configuration/non-working-days.service';
import { WorkRegionModel } from '../../../models/configuration/nonWorkingDays/work-region.model';
import { ConfigurationService } from '../configuration.service';
import { TdoClientConfigurationModel } from '../../../models/clients/tdo-client-configuration.model';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { CfgTimeZoneModel } from '../../../models/configuration/cfg-timezone';
import { OperatoryDataModel } from 'src/app/models/clients/operatory-data.model';
import { OperatoriesService } from '../operatories/operatories.service';

interface Form {
  id: string;
  dFormID: string;
  name: string;
  filledBy: string;
  isOpenByDefault: boolean;
  isAddByDefault: boolean;
  formOrder: number;
}

interface Procedure {
  id: string;
  code: string;
  description: string;
  name: string;
  forms: Form[];
  deletedForms: Form[];
  speciality: string; // enumMedicalSpeciality
  partOfAppointmentGroup: boolean;
  appointmentAddByDefault: boolean;
  partOfVisitGroup: boolean;
  visitAddByDefault: boolean;
  enumProcedureActionCategoryID: string;
}

@Component({
  selector: 'app-office-locations',
  templateUrl: './office-locations.component.html',
  styleUrls: ['./office-locations.component.css']
})
export class OfficeLocationsComponent implements OnInit, AfterViewInit, AfterContentInit {
  @ViewChild('locationTable') locationTable: TdoTableV2Component;

  clientList: any;
  locationList: ClientLocationDataModel[];

  selectedClient: any;
  selectedLocation: ClientLocationDataModel;

  saveIndicatorVisible: boolean = false;
  saveButtonText: string = 'Save';
  isNewLocation: boolean = false;
  isBusy: boolean = true;

  searchPredicate: (data: any, filter: string) => boolean;

  procedures: Procedure[];

  editedLocations: ClientLocationDataModel[] = [];
  addresses: AddressDataModel[];
  workRegions: WorkRegionModel[];
  timezones: CfgTimeZoneModel[];

  selectedLocationOperatories: OperatoryDataModel[];

  constructor(private operatoriesService: OperatoriesService,
    private locService: OfficeLocationsService,
    private dialogService: DialogService,
    private globals: Globals,
    private dialog: MatDialog,
    private proceduresService: ProceduresService,
    private nwds: NonWorkingDaysService,
    public configurationService: ConfigurationService,
    private snackbar: MatSnackBar) {
    this.searchPredicate = (dataSearch: ClientLocationDataModel, filter: string) => {
      return dataSearch.Name.toLowerCase().includes(filter);
    };
  }
 
  ngAfterContentInit(): void {
    this.nwds.getScheduleNonWorkingRegions().subscribe((res) => {
      this.workRegions = res;
    });
    this.locService.getTimeZones().subscribe((res) => {
      this.timezones = res;
    });
  }

  ngAfterViewInit(): void {
    this.loadServiceData();
  }

  ngOnInit() {

  }

  loadServiceData() {
    this.locService.getClients().subscribe(data => {
      this.clientList = data;
      if (this.clientList.length > 0) {
        // Try to locate current users client
        const client = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
        if (client) {          
          this.selectedClient = client;
        } else {
          this.selectedClient = this.clientList[0];
        }
      }

      this.getProcedures();

      this.locService.getClientLocations(this.selectedClient.TDOCID).subscribe((ldata) => {
        this.locationList = ldata;

        if (this.locationList.length > 0) {
          const loc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
          if (loc) {
            this.selectedLocation = loc;
            this.selectLocation(loc);
          } else {
            this.selectedLocation = this.locationList[0];
            this.selectLocation(this.locationList[0]);
          }

          const ivl = setInterval(() => {
            if (this.locationTable) {
              clearInterval(ivl);
              this.locationTable.setSelectedModel(this.selectedLocation);
            }
          }, 100);

          if (!this.selectedLocation.dataOrganizations) {
            this.selectedLocation.dataOrganizations = [];
          }

          if (this.selectedLocation.dataOrganizations.length === 0) {
            const org = new OrganizationDataModel();
            org.enumOrganizationTypeId = '00000044-1000-0000-0000-000000000001';
            org.OrganizationName = this.selectedLocation.Name;
            org.TDOIC = parseInt(this.globals.TDOCID);
            org.dataAddress = new AddressDataModel();
            this.selectedLocation.dataOrganizations.push(org);
          }

          if (!this.selectedLocation.dataOrganizations[0].dataAddress) {
            this.selectedLocation.dataOrganizations[0].dataAddress = new AddressDataModel();
            const newAddress = new AddressDataModel();
            newAddress.LOCID = this.globals.LOCID;
            newAddress.Address1 = '';
            newAddress.Address2 = '';
            newAddress.Address3 = '';
            newAddress.PostCode = '';
            newAddress.State = '';
            newAddress.City = '';
            newAddress.enumAddressCategoryID = '';
            newAddress.Suburb = '';
            this.selectedLocation.dataOrganizations[0].dataAddress = newAddress;
          }

          this.addresses = [this.selectedLocation.dataOrganizations[0].dataAddress];
          this.isBusy = false;
          // this.refreshTableViewData(this.locationList);
        }
        this.isBusy = false;
      });

    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  onChangeClient(event) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(event.value);
          return;
        } else {
          this.locationTable.selectionControl.select(this.selectedClient);
        }
      });
    } else {
      this.changeClient(event.value);
    }
  }

  changeClient(client: TdoClientConfigurationModel) {
    this.isBusy = true;
    this.selectedClient = client;
    this.procedures = [];
    this.locService.getClientLocations(this.selectedClient.TDOCID).subscribe((ldata) => {
      this.locationList = ldata;
      this.locationTable.updateData(this.locationList);

      if (this.locationList.length > 0) {
        const loc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
        if (loc) {
          this.selectedLocation = loc;
        } else {
          this.selectedLocation = this.locationList[0];
        }

        const ivl = setInterval(() => {
          if (this.locationTable) {
            clearInterval(ivl);
            this.locationTable.setSelectedModel(this.selectedLocation);
          }
        }, 100);

        this.getProcedures();

        if (!this.selectedLocation.dataOrganizations) {
          this.selectedLocation.dataOrganizations = [];
        }

        if (this.selectedLocation.dataOrganizations.length === 0) {
          const org = new OrganizationDataModel();
          org.enumOrganizationTypeId = '00000044-1000-0000-0000-000000000001';
          org.OrganizationName = this.selectedLocation.Name;
          org.TDOIC = parseInt(this.selectedClient.TDOCID);
          org.dataAddress = new AddressDataModel();
          this.selectedLocation.dataOrganizations.push(org);
        }

        if (!this.selectedLocation.dataOrganizations[0].dataAddress) {
          this.selectedLocation.dataOrganizations[0].dataAddress = new AddressDataModel();
          const newAddress = new AddressDataModel();
          newAddress.LOCID = this.selectedLocation.LOCID.toString();
          newAddress.Address1 = '';
          newAddress.Address2 = '';
          newAddress.Address3 = '';
          newAddress.PostCode = '';
          newAddress.State = '';
          newAddress.City = '';
          newAddress.enumAddressCategoryID = '';
          newAddress.Suburb = '';
          this.selectedLocation.dataOrganizations[0].dataAddress = newAddress;
        }

        this.addresses = [this.selectedLocation.dataOrganizations[0].dataAddress];
        // this.refreshTableViewData(this.locationList);
      }
      this.isBusy = false;
    }, err => {
      this.isBusy = false;
      console.log(err);
    });
  }

  getProcedures() {
    this.proceduresService.getClientProcedures(this.selectedClient.TDOCID).subscribe((res) => {
      this.procedures = res.map<Procedure>(o => ({
        id: o.CaseProcedureId,
        enumProcedureActionCategoryID: o.enumProcedureActionCategoryID,
        code: o.Code,
        description: o.Description,
        name: o.ProcedureName,
        forms: o.cfgCaseProcedureForms.length !== 0 ?
          o.cfgCaseProcedureForms.map<Form>(o => ({
            id: o.CaseProcedureFormId,
            dFormID: (o as any).cfgDForm ? (o as any).cfgDForm.DFormId : '',
            name: (o as any).cfgDForm ? (o as any).cfgDForm.DFormName : 'No Form Name',
            filledBy: o.enumFormFilledByID,
            isOpenByDefault: o.isOpenByDefault,
            isAddByDefault: o.isAddByDefault,
            formOrder: o.formOrder
          })) : [],
        deletedForms: [],
        speciality: o.enumMedicalSpecialtyID,
        partOfAppointmentGroup: false,
        appointmentAddByDefault: false,
        partOfVisitGroup: false,
        visitAddByDefault: false
      }));
    });
  }

  onNew(event) {

    //var br_offset = new Date().getTimezoneOffset();  // return offset in minutes
    //var offset = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1]  ;  // GMT-0800
    //offset = offset.substring(0, 6)+':'+offset.substring(6);
    //this.selectedLocation.TZID = this.timezones.find(f => f.Offset == br_offset).TZID 
    //console.log(br_offset, this.selectedLocation.TZID);


    this.configurationService.setDirty();
    const model = new ClientLocationDataModel();
    model.Name = 'New Location';
    model.TDOCID = this.selectedLocation.TDOCID;
    this.selectedLocation = model;

    const org = new OrganizationDataModel();
    org.enumOrganizationTypeId = '00000044-1000-0000-0000-000000000001';
    org.OrganizationName = this.selectedLocation.Name;
    org.TDOIC = parseInt(this.selectedClient.TDOCID);
    org.dataAddress = new AddressDataModel();
    if (!this.selectedLocation.dataOrganizations) {
      this.selectedLocation.dataOrganizations = [];
    }
    this.selectedLocation.dataOrganizations.push(org);

    this.selectedLocation.dataOrganizations[0].dataAddress = new AddressDataModel();

    var br_offset = new Date().getTimezoneOffset();  // return offset in minutes
    
    this.selectedLocation.TZID = this.timezones.find(f => f.Offset == -br_offset).TZID 

    const newAddress = new AddressDataModel();
    newAddress.LOCID = '0';
    newAddress.Address1 = '';
    newAddress.Address2 = '';
    newAddress.Address3 = '';
    newAddress.PostCode = '';
    newAddress.State = '';

    newAddress.City = '';
    newAddress.enumAddressCategoryID = '';
    newAddress.Suburb = '';
    this.selectedLocation.dataOrganizations[0].dataAddress = newAddress;
    this.addresses = [newAddress];

    this.locationList.unshift(model);
    this.locationTable.updateData();
    this.locationTable.setSelectedModel(model);
    // this.refreshTableViewData(this.locationList);
    this.editedLocations.push(model);
  }

  onSave(event) {


    if(this.selectedLocation.FormsRepoCaseProcedureId == undefined)
    {
    let msg = `Please select a Forms Repository Proceure?`;
    this.dialogService.openConfirmDialog(msg, false, false).subscribe((result) => {
      

        });
        return;
    }

    this.saveIndicatorVisible = true;
    this.saveButtonText = 'Saving ...';
    this.isBusy = true;
    this.locService.saveLocation(this.selectedLocation).subscribe((resp) => {
      this.configurationService.setClean();
      this.refreshTableViewData(this.locationList);

      /*if (this.addressComponent.data && this.addressComponent.data.length > 0) {
        //this.locService.saveLocationAddresses
      }*/

      if (this.selectedLocation.dataOrganizations) {
        if (this.selectedLocation.dataOrganizations[0]) {
          if (!this.selectedLocation.dataOrganizations[0].OrganizationName) {
            this.selectedLocation.dataOrganizations[0].OrganizationName = this.selectedLocation.Name;
          }

          if (this.selectedLocation.dataOrganizations[0].TDOIC === 0) {
            this.selectedLocation.dataOrganizations[0].TDOIC = this.selectedLocation.TDOCID;
          }
        }
      }

      if (this.selectedLocation.dataOrganizations && this.selectedLocation.dataOrganizations[0]) {
        this.selectedLocation.dataOrganizations[0].OrganizationName = this.selectedLocation.Name;
      }

      this.locService.saveLocationOrganizationAndAddress(this.selectedLocation.dataOrganizations[0]).subscribe((res) => {
        const modIdx = this.locationList.find(p => p === this.selectedLocation);
        if (modIdx) {
          this.selectedLocation = resp;
        }
        this.selectedLocation.dataOrganizations[0] = res;
        this.snackbar.open('Location save successful', '', { duration: 5000 });
        this.isBusy = false;
      });
    });

    /*this.locService.saveOps(this.isNewLocation, this.selectedLocation).subscribe(resp => {
      this.isBusy = false;

      if (this.isNewLocation) {
        this.locationList.push(this.selectedLocation);
        this.isNewLocation = false;
      }

      this.refreshTableViewData(this.locationList);

      this.snackbar.open('Location save successful', '', {duration: 5000});
      this.isBusy = false;

    }, err => {
      console.log('save Error');
      this.isBusy = false;
    });*/
  }

  // Data change
  refreshTableViewData(models: ClientLocationDataModel[]) {
    /*this.locationList = models;

    this.tableViewData = Array.from(this.locationList, (_) => {
      const model = new TableViewData();
      model.Name = _.Name;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'Name', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.Name.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();
    }

    this.isBusy = false;*/
  }

  onNameInput(event: Event) {
    if (!this.editedLocations.includes(this.selectedLocation)) {
      this.editedLocations.push(this.selectedLocation);
    }
    this.refreshTableViewData(this.locationList);
  }

  onShortNameInput(event: Event) {
    if (!this.editedLocations.includes(this.selectedLocation)) {
      this.editedLocations.push(this.selectedLocation);
    }
    // this.refreshTableViewData(this.locationList);
  }

  getProcedureById(FormsRepoCaseProcedureId: string) {
    if (this.procedures) {
      const proc = this.procedures.find(p => p.id === FormsRepoCaseProcedureId);
      if (proc) {
        return proc.name;
      }
    } else {
      return null;
    }
  }

  openProcedureSelector(event: MouseEvent) {
    const model = new ProcedureSelectionDialogModel();
    model.datasource = this.procedures;
    this.dialogService.openProcedureDialog(model).subscribe((res) => {
      if (res) {
        this.selectedLocation.FormsRepoCaseProcedureId = res.id;
      }
    });
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectLocation(event.model);
          return;
        } else {
          this.locationTable.selectionControl.select(this.selectedClient);
        }
      });
    } else {
      this.selectLocation(event.model);
    }
  }

  selectLocation(model: ClientLocationDataModel) {
    this.selectedLocation = model;
    this.operatoriesService.getLocationOperatories(this.selectedLocation.LOCID.toString()).subscribe((odata) => {
      this.selectedLocationOperatories = odata;

      if (this.locationList.length > 0) {
        if (!this.selectedLocation.dataOrganizations) {
          this.selectedLocation.dataOrganizations = [];
        }

        if (this.selectedLocation.dataOrganizations.length === 0) {
          const org = new OrganizationDataModel();
          org.enumOrganizationTypeId = '00000044-1000-0000-0000-000000000001';
          org.OrganizationName = this.selectedLocation.Name;
          org.TDOIC = this.selectedLocation.TDOCID;
          org.dataAddress = new AddressDataModel();
          this.selectedLocation.dataOrganizations = [];
          this.selectedLocation.dataOrganizations.push(org);
        }

        if (!this.selectedLocation.dataOrganizations[0].dataAddress) {
          this.selectedLocation.dataOrganizations[0].dataAddress = new AddressDataModel();
          const newAddress = new AddressDataModel();
          newAddress.LOCID = this.selectedLocation.TDOCID.toString();
          newAddress.Address1 = '';
          newAddress.Address2 = '';
          newAddress.Address3 = '';
          newAddress.PostCode = '';
          newAddress.State = '';
          newAddress.City = '';
          newAddress.enumAddressCategoryID = '';
          newAddress.Suburb = '';
          this.selectedLocation.dataOrganizations[0].dataAddress = newAddress;
        }

        this.addresses = [this.selectedLocation.dataOrganizations[0].dataAddress];
        // this.refreshTableViewData(this.locationList);
        // this.locationTable.updateData();
      }
      this.isBusy = false;
    });
  }

  openOrganizationDialog(viewOnly: boolean, organizationID: string) {
    const dialogRef = this.dialog.open(OrganizationConfigurationDialogComponent, {
      width: '700px',
      height: '900px',
      panelClass: 'dialog',
      data: {
        isDialogMode: true,
        isViewOnly: viewOnly,
        enumOrganizationTypeId: Constants.emptyGuid, // enterprise enumOrganizationTypeId
        organizationId: organizationID,
        showOrganizationTypeSelection: false
      }
    });
  }

  getWorkRegion(WorkRegionID: string) {
    if (this.workRegions && WorkRegionID) {
      const r = this.workRegions.find(p => p.WorkRegionID.toLowerCase() === WorkRegionID.toLowerCase());
      if (r) {
        return r;
      }
    }

    return null;
  }

  onRegionChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }

  getTimeZone(TZID: string) {
    if (this.timezones && TZID) {
      const r = this.timezones.find(p => p.TZID.toLowerCase() === TZID.toLowerCase());
      if (r) {
        return r;
      }
    }

    return null;
  }

  onTZChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }

  getOperatoryById(operatoryId: string) {
    if (this.selectedLocationOperatories) {
      const operatory = this.selectedLocationOperatories.find(p => p.OperatoryId === operatoryId);
      return operatory;
    } else {
      return null;
    }
  }
}
